import { useTranslation } from "react-i18next";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="page-footer">
            <p className="mb-0">{t('copyright')} © {new Date().getFullYear()}. {t('al_reserved')}.</p>
        </footer>
    )
}

export default Footer;